import "./contact.styles.scss";

const ContactUs = () => {
  return (<div className="contact-us">
    <h1>Contact Us!</h1>
    <h3>For general or customer service inquiries</h3>
    <p>hello@SourcedFashionInc.com</p>
    <h3>Don't see a job listed?</h3>
    <p>Email us at careers@SourcedFashionInc.com</p>
    </div>
    );
};

export default ContactUs;
